module.exports = "https://assets.localphysio.net.au/_next/static/images/2938186-6426fa3cd92b5247df7f3495e2f98663.jpg";